// extracted by mini-css-extract-plugin
export default {"target_product":"S1","retake":"T1","product_info":"U1","icon":"V1","target_image":"W1","background":"X1","product_info_desktop":"Y1","info":"Z1","title":"a2","benefits":"b2","benefit":"c2","accordeon_wrapper":"e2","ingredients_wrapper":"f2","info_wrapper":"g2","product_wrapper":"h2"};
    if(module.hot) {
      // 1711717535328
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  